import { combineReducers } from 'redux'

import challengeReducer from './challenge-reducer'
import challengesReducer from './challenges-reducer'

export default combineReducers({
  challenges: challengesReducer,
  challenge: challengeReducer,
})
